import { render } from "./deleteConfirmPopup.vue?vue&type=template&id=bc3944ac&ts=true"
import script from "./deleteConfirmPopup.vue?vue&type=script&lang=ts"
export * from "./deleteConfirmPopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__